import Seo from "@/components/Seo";
import { Reveal } from "@/components/Reveal";
import { SITE, LAST_UPDATED } from "@/data/site";

export default function LegalLayout({ title, description, path, intro, children }) {
  return (
    <>
      <Seo title={title} description={description} path={path} />
      <article className="mx-auto max-w-3xl px-5 py-16 sm:px-8 lg:py-24">
        <Reveal>
          <p className="text-sm font-semibold uppercase tracking-[0.15em] text-primary">Legal</p>
          <h1 className="mt-3 font-heading text-4xl font-bold tracking-tight text-foreground sm:text-5xl">
            {title}
          </h1>
          <p className="mt-4 text-sm text-muted-foreground">Last updated: {LAST_UPDATED}</p>
          {intro && <p className="mt-6 text-lg leading-relaxed text-muted-foreground">{intro}</p>}
        </Reveal>

        <Reveal delay={0.05} className="prose-legal mt-10 space-y-8">
          {children}
        </Reveal>

        <div className="mt-12 rounded-2xl border border-border bg-card p-6">
          <p className="text-sm text-muted-foreground">
            Questions about this policy? Contact us at{" "}
            <a href={`mailto:${SITE.supportEmail}`} className="font-medium text-primary hover:underline">
              {SITE.supportEmail}
            </a>
            .
          </p>
        </div>
      </article>
    </>
  );
}

export function Section({ heading, children }) {
  return (
    <section>
      <h2 className="font-heading text-2xl font-semibold tracking-tight text-foreground">{heading}</h2>
      <div className="mt-3 space-y-3 text-base leading-relaxed text-muted-foreground">{children}</div>
    </section>
  );
}
